
export const getEnvironment = (): string => {
  return process.env.ENVIRONMENT || 'local';
};
